<mat-form-field [formGroup]="form"
                [attr.data-symbol]="SEATS_AMOUNT_INPUT_CONFIG.unit"
                class="mat-block mat-block_with_symbol mat-block_placeholder-top">
  <input matInput
         npNumber
         [formControlName]="controlName"
         [placeholder]="SEATS_AMOUNT_INPUT_CONFIG.placeholder"
         [maxValue]="SEATS_AMOUNT_INPUT_CONFIG.maxValue"
         [maxInputLength]="SEATS_AMOUNT_INPUT_CONFIG.maxInputLength"
         [allowFloat]="SEATS_AMOUNT_INPUT_CONFIG.allowFloat"
         [NumberInput]="true"
         [(ngModel)]="seats" />
</mat-form-field>
